export enum FormErrorDisplayMode {
    AlwaysShowAllErrors = 1,
    AlwaysHideErrors = 2,
    AlwaysShowFirstError = 3,
    AlwaysHideErrorMessages = 4,
    AutoShowAllErrors = 5,
    AutoShowFirstError = 6,
    AutoHideErrorMessages = 7
}

export default FormErrorDisplayMode;